import * as React from 'react';

/** Provided by SectionLayout; consumed by FormLayout's StickyFooter to portal into the footer slot. */
export const SectionLayoutFooterSlotContext = React.createContext<HTMLElement | null>(null);
